import { Data } from '@shared/api/types';
import { DataTable } from '@shared/ui/components/DataTable';

import PrintWristbandButton from '@admin/wristbands/components/PrintWristbandButton/PrintWristbandButton';

type AccessVoucherData = App.Domain.Wristband.Data.AccessVoucherData;

type Columns = 'period' | 'day' | 'redeemedAt' | 'actions';

type AccessVouchersDataTableProps = {
  accessVouchers: Data<AccessVoucherData>;
  columns?: Partial<{ [k in Columns]: boolean }>;
  avoidPagination?: boolean;
  withoutFilters?: boolean;
};

export function AccessVouchersDataTable({
  accessVouchers,
  columns = {},
  avoidPagination = false,
  withoutFilters = false,
}: AccessVouchersDataTableProps) {
  return (
    <DataTable<AccessVoucherData>
      data={accessVouchers}
      columns={[
        {
          visible: columns.period !== false,
          name: 'period',
          sortable: false,
          render: (row) => row.accessVoucherTemplate?.period?.name,
        },
        {
          visible: columns.day !== false,
          name: 'day',
          sortable: false,
          render: (row) => (row.accessVoucherTemplate?.day ? row.accessVoucherTemplate?.day : 'Combi'),
        },
        {
          visible: columns.redeemedAt !== false,
          name: 'redeemedAt',
          type: 'datetime',
        },
        {
          visible: columns.actions !== false,
          render: (row) =>
            row.redeemedAt ? (
              <PrintWristbandButton accessVoucher={row} onPrint={accessVouchers.refresh} variant="outline" reprint />
            ) : (
              <PrintWristbandButton accessVoucher={row} onPrint={accessVouchers.refresh} />
            ),
          sortable: false,
          type: 'actions',
        },
      ]}
      avoidPagination={avoidPagination}
      withoutFilters={withoutFilters}
    />
  );
}
